<div class="in-app">
  <app-sidebar></app-sidebar>

  <div class="in-app-content-wrapper">
    <router-outlet></router-outlet>
  </div>
</div>

<app-trial-subscription-modal (submit)="openBuyClientNumberModal()" (close)="openBuyClientNumberModal()"></app-trial-subscription-modal>

<app-missing-subscription-error-modal
  (close)="onBuyClientNumberModalClose()"
  (chooseNumber)="openBuyClientNumberModal()"
></app-missing-subscription-error-modal>

<app-buy-client-number-modal
  (close)="onBuyClientNumberModalClose()"
  (submit)="createAndOpenClientNumberPaymentLink($event)"
></app-buy-client-number-modal>

<app-loader></app-loader>
<app-notification-bar></app-notification-bar>
<app-toast></app-toast>
